import type { UserQuery } from '@/generated/graphql'
import { activePlan } from './active-plan'

export type PlanFraming = 'day' | 'step'

const OVERRIDE_PARAM = 'planFraming'
const OVERRIDE_KEY = 'ff:planFraming'

// Dev-only QA seam: `?planFraming=step|day` pins the arm for the tab session.
function devOverride(): PlanFraming | null {
  if (!import.meta.env.DEV) return null
  try {
    const fromUrl = new URLSearchParams(window.location.search).get(
      OVERRIDE_PARAM,
    )
    if (fromUrl === 'step' || fromUrl === 'day') {
      sessionStorage.setItem(OVERRIDE_KEY, fromUrl)
    }
    const stored = sessionStorage.getItem(OVERRIDE_KEY)
    return stored === 'step' || stored === 'day' ? stored : null
  } catch {
    return null
  }
}

export function planFraming(user: UserQuery['me'] | undefined): PlanFraming {
  const forced = devOverride()
  if (forced) return forced
  return activePlan(user)?.stepByStep ? 'step' : 'day'
}
